import React from "react";
import { CategoryBreakdown } from "./DessertsBreakdown";

// Bright matcha + coffee palette — leaf greens and roasted browns alternating
// so the pie visually distinguishes drink families without needing a legend.
const DRINK_COLOURS = [
  "#6B7B4A", "#8D5A2C", "#8FA469", "#B57C3B", "#5D6C42",
  "#C48A44", "#A3B18A", "#D9A066", "#4E5B36", "#7C4F1E",
];

/**
 * Best-selling drinks breakdown — mirrors DessertsBreakdown / PastryBreakdown
 * but joins TWO product categories together: "Matcha Drinks" + "Coffee".
 * The category-breakdown endpoint accepts a comma-separated `category` list
 * and returns each item's live category so admins can still tell them apart.
 *
 * No reclassify button — drinks use the per-item keyword classifier on POS
 * commit (matcha/hojicha → Matcha Drinks, latte/espresso/mocha → Coffee),
 * so there's nothing to bulk-migrate.
 */
export default function DrinksBreakdown() {
  return (
    <CategoryBreakdown
      category="Drink - Matcha,Drink - Coffee,Matcha Drinks,Coffee"
      label="Drinks"
      headline="Matcha · Hojicha · Latte · Espresso · Mocha · by flavour"
      subhead={
        <>
          Auto-tabulated from your POS imports — anything the classifier tags
          <strong className="text-ink"> Matcha Drinks</strong> or
          <strong className="text-ink"> Coffee</strong> lands here so you can
          see your best-sellers across the whole drinks bar in one pie.
        </>
      }
      testidPrefix="sales-drinks"
      colours={DRINK_COLOURS}
      emptyBody={<>
        Upload your GEBME export in <strong className="text-ink">Import from POS</strong>. Drink
        names containing <em>matcha / hojicha</em> auto-tag as Matcha Drinks; <em>latte / espresso /
        mocha / americano / coffee</em> auto-tag as Coffee — both populate this view.
      </>}
      emptyHint={<>
        A drink not landing here? Re-upload and pick <strong>+ Create as Drink</strong> on the review
        screen to force the classification.
      </>}
    />
  );
}
